import React, { useState } from 'react';
import {
  Card,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { CardHeader } from '@cordata/buffet';
import { startCase, get } from 'lodash';
import { compareAsc, compareDesc } from 'date-fns';
import Accordion from '~/components/common/Accordion';
import { MatchStatus } from '~/utils/const/identity';
import { useQueryParam, } from '~/utils';
import EhrDataRow from './EhrDataRow';

const MRN_SORT_ORDER = [
  MatchStatus.NeedToBeApproved,
  MatchStatus.Disputed,
  MatchStatus.Unmatched,
  MatchStatus.OnHold,
  MatchStatus.Approved,
  MatchStatus.Rejected,
];

const sortOptions = [{
  label: 'Status',
  property: 'attributes.matchStatusId',
  sortFn: (a, b) => MRN_SORT_ORDER.indexOf(a) - MRN_SORT_ORDER.indexOf(b),
}, {
  label: 'Dispute Date: New to old',
  property: 'attributes.matchStatusDate',
  sortFn: compareDesc,
}, {
  label: 'Dispute Date: Old to new',
  property: 'attributes.matchStatusDate',
  sortFn: compareAsc,
}];

interface EhrDataCardProps {
  matchStatusId: string;
  data: any[];
}

const EhrDataCard = ({
  matchStatusId,
  data,
}: EhrDataCardProps) => {
  const [expand, setExpand] = useQueryParam('expand');
  const [selectedSort, setSelectedSort] = useState(sortOptions[0]);

  MRN_SORT_ORDER.unshift(MRN_SORT_ORDER.splice(MRN_SORT_ORDER.indexOf(matchStatusId), 1)[0]);

  data.sort((a, b) =>
    selectedSort.sortFn(get(a, selectedSort.property), get(b, selectedSort.property)));

  return (
    <div className="w-100">
      <Card>
        <CardHeader
          inverse
          color="secondary"
          action={
            <UncontrolledButtonDropdown
              className="w-100"
            >
              <DropdownToggle
                size="sm"
                color="light"
                outline
                caret
              >
                Sort By: {selectedSort.label}
              </DropdownToggle>

              <DropdownMenu
                right
              >
                {sortOptions.map(o => (
                  <DropdownItem
                    onClick={() => setSelectedSort(o)}
                  >
                    {o.label}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          }
        >
          Electronic Health Record
        </CardHeader>

        {data.length > 0 && (
          <Accordion
            openPanel={expand}
            setOpenPanel={setExpand}
            items={data.map(d => ({
              title: `MRN: ${d.attributes.lookuppersonid} - ${startCase(MatchStatus[d.attributes.matchStatusId])}`,
              body: (
                <EhrDataRow
                  data={d}
                  matchStatusId={matchStatusId}
                />
              ),
            }))}
          />
        )}
      </Card>
    </div>
  );
};

export default EhrDataCard;
